import React from 'react';
import { t } from 'Src/i18n';
import { UpsellsBlock as UpsellsBlockBase } from 'Components/widgets/upsells-block/UpsellsBlock';

const hasPersonRentedAnUpsell = (upsells: Array<any>, personId: string) =>
  upsells.some((upsell) =>
    upsell.pricingInfo.attendees.some(
      (attendee: { id: string; rentedAmount: { value: number } }) =>
        attendee.id === personId && attendee.rentedAmount.value !== 0,
    ),
  );

const UpsellsBlock = UpsellsBlockBase as React.ComponentType<{
  person: ProposalAttendeesType;
  upsells: ReadonlyArray<UpsellRental | UpsellActivity>;
}>;
type Props = {
  participants: ReadonlyArray<ProposalAttendeesType>;
  proposal: Proposal;
  isChild: boolean;
};
export const GetParticipantsActivities = ({ participants, proposal, isChild }: Props) => {
  return participants.map((person, index) => (
    <React.Fragment key={person.id}>
      {hasPersonRentedAnUpsell(
        [...proposal.additionalServices.activities, ...proposal.additionalServices.rentals],
        person.id,
      ) && (
        <p className="mb-10 mt-0 text-20 font-bold">
          {isChild
            ? `${t('booking.confirmation.child')} ${index + 1}`
            : `${t('booking.confirmation.adult')} ${index + 1}`}
        </p>
      )}
      <UpsellsBlock person={person} upsells={proposal.additionalServices.activities} />
      <UpsellsBlock person={person} upsells={proposal.additionalServices.rentals} />
    </React.Fragment>
  ));
};
